import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sanmarino-market/artifacts/x01s3ury_Contemporary%20Emblem%20Logo%20for%20SAN%20MARINO%20MARKET.png";

export default function Logo({ size = 40, showText = true, variant = "default" }) {
  return (
    <div className="flex items-center gap-2">
      <img
        src={LOGO_URL}
        alt="San Marino Market"
        style={{ width: size, height: size }}
        className="object-contain rounded-lg"
      />
      {showText && (
        <div className="hidden sm:block leading-none">
          <div className={`text-lg font-black ${variant === "light" ? "text-white" : "text-[#1d3d3a]"}`}>
            SAN MARINO
          </div>
          <div className="text-[11px] tracking-[0.25em] text-[#e86a24] font-black -mt-0.5">
            MARKET
          </div>
        </div>
      )}
    </div>
  );
}
